module.exports = __webpack_public_path__ + "virgo-ba06e4a486539b11ad42.png";